import { Outlet } from 'react-router-dom';
import MyAppBar from './MyAppBar';
import FooterComponent from './Footer';
import { AuthData, ManualItem } from '../types';

interface AppLayoutProps {
  manualItems?: ManualItem[];
  loginData: null | AuthData;
}

const AppLayout = ({ manualItems = [], loginData }: AppLayoutProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {loginData?.UserId && <MyAppBar
        loginData={loginData}
        manualItems={manualItems.filter(item => item.isActive && item.locations.appBar)} 
      />}
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
      {loginData?.UserId && <FooterComponent 
        manualItems={manualItems.filter(item => item.isActive && item.locations.footer)} 
      />}
    </div>
  );
};

export default AppLayout;